export default "__VITE_ASSET__CeTUL7Jt__"